import { Fragment } from "react";

import Hint from "~/components/Hint";
import type { ExcelRowError } from "~/modules/billing/api/processedInvoice/processedInvoiceTypes.ts";

type Props = { rowNumber: number; excelErrors: ExcelRowError[] };

const ExcelImportErrors = ({ excelErrors, rowNumber }: Props) => {

	return <div className="col-span-5 mb-2">
		<Hint theme="error">
			<div className="mb-2 font-bold">Folgende Fehler sind beim Import aus Excel aufgetreten (Zeile: {rowNumber}):</div>
			<div className="grid grid-cols-3">
				<div className="font-medium">Bezeichnung</div>
				<div className="font-medium">Originalwert</div>
				<div className="font-medium">Fehler</div>
				{excelErrors.map((error, index) => {
					return <Fragment key={index}>
						<div className="">{error.attributeName}</div>
						<div className="">{error.originalValue}</div>
						<div className="">{error.errorMessage}</div>
					</Fragment>;


				})}
			</div>
		</Hint>
	</div>;
};

export default ExcelImportErrors;